export default __webpack_public_path__ + "static/media/Close-new.b2f59c6f.svg";